import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

export const usePaystack = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const initializePayment = async (amount, tokenAmount, onSuccess, onError) => {
    if (!user) {
      const error = 'User not authenticated';
      setError(error);
      onError?.(error);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      // Initialize Paystack payment
      const handler = window.PaystackPop.setup({
        key: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY,
        email: user.email,
        amount: amount * 100, // Amount in kobo (multiply by 100)
        currency: 'ZAR',
        ref: `tokens_${user.id}_${Date.now()}`,
        metadata: {
          user_id: user.id,
          token_amount: tokenAmount,
          custom_fields: [
            {
              display_name: "Token Purchase",
              variable_name: "token_purchase",
              value: `${tokenAmount} tokens`
            }
          ]
        },
        callback: function(response) {
          // Payment successful
          console.log('Payment successful:', response);
          onSuccess?.(response, tokenAmount);
        },
        onClose: function() {
          // Payment cancelled
          console.log('Payment cancelled');
          onError?.('Payment was cancelled');
        }
      });

      handler.openIframe();
    } catch (err) {
      console.error('Error initializing payment:', err);
      setError(err.message);
      onError?.(err.message);
    } finally {
      setLoading(false);
    }
  };

  return {
    initializePayment,
    loading,
    error
  };
};
